export default __webpack_public_path__ + "static/hook-cff0dead3389e95fee56f213eefc99bc.png";